/* Small independent bottle movements; no input is captured by the decoration. */
if (!customElements.get('bfh-bottle-motion')) {
  customElements.define('bfh-bottle-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const hero = this.closest('.bfh-hero--noel');
      if (!hero) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = true;
      this.update = () => {
        this.toggleAttribute('data-paused', !this.visible || document.hidden || this.motion.matches);
        if (this.motion.matches || !this.visible || document.hidden) this.resetPointer();
      };
      this.motion.addEventListener('change', this.update, {signal});
      document.addEventListener('visibilitychange', this.update, {signal});
      if (window.IntersectionObserver) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.update();
        });
        this.observer.observe(this);
      }
      if (window.matchMedia('(pointer: fine)').matches) {
        hero.addEventListener('pointermove', event => {
          if (this.motion.matches || !this.visible || document.hidden) return;
          const rect = hero.getBoundingClientRect();
          this.pointer = {x: (event.clientX - rect.left) / rect.width - .5,
            y: (event.clientY - rect.top) / rect.height - .5};
          if (this.frame != null) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.style.setProperty('--bfh-bottle-x', (this.pointer.x * 8).toFixed(2) + 'px');
            this.style.setProperty('--bfh-bottle-y', (this.pointer.y * 5).toFixed(2) + 'px');
            this.style.setProperty('--bfh-bottle-tilt', (this.pointer.x * 2.4).toFixed(2) + 'deg');
          });
        }, {passive: true, signal});
        hero.addEventListener('pointerleave', () => this.resetPointer(), {passive: true, signal});
      }
      this.update();
    }
    resetPointer() {
      if (this.frame != null) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.style.removeProperty('--bfh-bottle-x');
      this.style.removeProperty('--bfh-bottle-y');
      this.style.removeProperty('--bfh-bottle-tilt');
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.resetPointer();
    }
  });
}
